const playerObjs = [];

export function init() {
    const playerEls = document.querySelectorAll(".js-audio-player-container");

    if (!playerEls) {
        return;
    }

    // There could be multiple forms so initialise each
    playerEls.forEach((el) => {
        let player = new AudioPlayer(el);

        let playerObj = {
            id: el.querySelector(".js-audio-player").id,
            player: player,
        };

        playerObjs.push(playerObj);

        player.setup();
    });
}

class AudioPlayer {
    constructor(audioPlayer) {
        this.audio = audioPlayer.querySelector(".js-audio-player");
        this.playPauseBtn = audioPlayer.querySelector(
            ".js-audio-player-play-pause"
        );
        this.previousTrackBtn = audioPlayer.querySelector(
            ".js-audio-player-prev-track"
        );
        this.nextTrackBtn = audioPlayer.querySelector(
            ".js-audio-player-next-track"
        );
        this.scrubbar = audioPlayer.querySelector(".js-audio-player-scrubbar");
        this.scrubbarInner = audioPlayer.querySelector(
            ".js-audio-player-scrubbar-inner"
        );
        this.duration = audioPlayer.querySelector(".js-audio-player-duration");
        this.time = audioPlayer.querySelector(".js-audio-player-time");
        this.playlistItemBtns = audioPlayer.querySelectorAll(
            ".js-audio-player-playlist-item"
        );
        this.playingTrackTitle = audioPlayer.querySelector(
            ".js-audio-player-playing-track-title"
        );

        this.currentTrack = null;
        this.trackLoaded = false;
    }

    strPadLeft(string, pad, length) {
        return (new Array(length + 1).join(pad) + string).slice(-length);
    }

    formatTime(time) {
        let seconds = 0,
            minutes = 0,
            hours = 0,
            output = "";

        time = Math.round(time);

        // Get number of hours
        hours = Math.floor(time / 3600);

        time = time - hours * 3600;

        // Get the number of minutes in time
        minutes = Math.floor(time / 60);

        time = time - minutes * 60;

        // Get the number of seconds remaining
        seconds = time % 60;

        output = `${this.strPadLeft(minutes, "0", 2)}:${this.strPadLeft(
            seconds,
            "0",
            2
        )}`;

        if (hours) {
            output = `${this.strPadLeft(hours, "0", 2)}:${output}`;
        }

        return output;
    }

    getTrackPlaytimeStorageKey(assetId = null) {
        const trackId = assetId ?? this.audio.dataset.currentTrackId;
        return `${trackId}-audio-playtime`;
    }

    getTrackCompletedStorageKey(trackId) {
        return `${trackId}-completed`;
    }

    trackTimeChanged() {
        this.time.innerHTML = this.formatTime(this.audio.currentTime);

        this.scrubbarInner.style.width = `${Number.parseFloat(
            (this.audio.currentTime / this.audio.duration) * 100
        ).toFixed(2)}%`;

        // Update localstorage value
        const currentTrackId = this.audio.dataset.currentTrackId;
        localStorage.setItem(
            this.getTrackPlaytimeStorageKey(currentTrackId),
            this.audio.currentTime
        );
    }

    trackEnded() {
        const _this = this,
            currentTrackId = _this.audio.dataset.currentTrackId;

        // Save a record of this track being completed
        const completedKey = _this.getTrackCompletedStorageKey(currentTrackId);
        localStorage.setItem(completedKey, true);

        // Remove the playtime storage item
        const playtimeKey = _this.getTrackPlaytimeStorageKey(currentTrackId);
        localStorage.removeItem(playtimeKey);

        // Update the playlist item to show it's been completed
        _this.playlistItemBtns[_this.currentTrack - 1]
            .querySelector(".js-track-duration")
            .classList.add("completed");

        _this.currentTrack =
            _this.currentTrack === _this.playlistItemBtns.length
                ? 1
                : _this.currentTrack + 1;
        _this.trackLoaded = false;

        _this.resetPlayStatus();

        _this.setTrack(true);
    }

    /**
     * Controls playback of the audio element.
     *
     **/
    playBack() {
        // Pause all other players
        playerObjs.forEach((playerObj) => {
            if (playerObj.id !== this.audio.id) {
                playerObj.player.audio.pause();
                playerObj.player.updatePlayStatus(false);
            }
        });

        if (this.audio.paused) {
            this.audio.play();
            this.updatePlayStatus(true);
        } else {
            this.audio.pause();
            this.updatePlayStatus(false);
        }
    }

    /**
     * Sets the duration of the track.
     */
    setDuration() {
        let formattedTime = this.formatTime(this.audio.duration);

        this.duration.innerHTML = formattedTime;
    }

    /**
     * Sets the track if it hasn't already been loaded yet.
     *
     **/
    setTrack(play = false) {
        var trackURL = this.audio.children[this.currentTrack - 1].src;

        this.audio.src = trackURL;
        this.audio.load();

        this.trackLoaded = true;

        this.setActiveAssetId();

        this.setTrackTitle();

        if (play) {
            this.setActiveItem();
            this.playBack();
        }
    }

    /**
     * Sets the activly playing asset ID on the player
     **/
    setActiveAssetId() {
        // Get the active asset ID and set on player
        let activeAssetID =
            this.playlistItemBtns[this.currentTrack - 1].dataset.assetId;

        this.audio.dataset.currentTrackId = activeAssetID;
    }

    /**
     * Sets the activly playing item within the playlist.
     **/
    setActiveItem() {
        // Remove active track from any currently active
        this.playlistItemBtns.forEach((btn) => {
            btn.classList.remove("playing");
        });

        // Add active class to current track
        this.playlistItemBtns[this.currentTrack - 1].classList.add("playing");
    }

    /**
     * Sets the text for the currently playing track.
     **/
    setTrackTitle() {
        this.playingTrackTitle.innerHTML =
            this.playlistItemBtns[this.currentTrack - 1].dataset.trackTitle;
    }

    /**
     * Updates both the large and small toggle buttons accordingly.
     *
     * @param audioPlaying A booean value indicating if audio is playing or paused.
     **/
    updatePlayStatus(audioPlaying) {
        if (audioPlaying) {
            this.playPauseBtn.classList.add("playing");

            this.playlistItemBtns[this.currentTrack - 1].classList.add(
                "playing"
            );
        } else {
            this.playPauseBtn.classList.remove("playing");

            this.playlistItemBtns[this.currentTrack - 1].classList.remove(
                "playing"
            );

            // Update localstorage value
            localStorage.setItem(
                this.getTrackPlaytimeStorageKey(),
                this.audio.currentTime
            );
        }

        if (this.previousTrackBtn && this.nextTrackBtn) {
            this.updateNextPreviousBtnStates();
        }
    }

    /**
     * Updates the next and previous buttons to be enabled or disabled
     * depending on the current track.
     **/
    updateNextPreviousBtnStates() {
        // Update next and previous buttons accordingly
        if (this.playlistItemBtns.length === 1) {
            this.previousTrackBtn.disabled = true;
            this.nextTrackBtn.disabled = true;
        } else {
            if (this.currentTrack === 1) {
                this.previousTrackBtn.disabled = true;
                this.nextTrackBtn.disabled = false;
            } else if (
                this.currentTrack > 1 &&
                this.currentTrack !== this.playlistItemBtns.length
            ) {
                this.previousTrackBtn.disabled = false;
                this.nextTrackBtn.disabled = false;
            } else if (this.currentTrack === this.playlistItemBtns.length) {
                this.previousTrackBtn.disabled = false;
                this.nextTrackBtn.disabled = true;
            }
        }
    }

    /**
     * Resets all toggle buttons to be play buttons.
     *
     **/
    resetPlayStatus() {
        this.playPauseBtn.classList.remove("playing");

        this.playlistItemBtns.forEach((btn) => {
            btn.classList.remove("playing", "loaded-track");
        });
    }

    /**
     * Sets up the audio player.
     * This is called on page load.
     **/
    setup() {
        const _this = this;

        // Loop over playlist items and find if any have been fully played
        // or part played
        _this.playlistItemBtns.forEach((btn) => {
            const assetId = btn.dataset.assetId,
                trackCompleted = localStorage.getItem(
                    _this.getTrackCompletedStorageKey(assetId)
                ),
                trackPlaytime = localStorage.getItem(
                    _this.getTrackPlaytimeStorageKey(assetId)
                );

            // Show visually if track has been completed
            if (trackCompleted) {
                btn.querySelector(".js-track-duration").classList.add(
                    "completed"
                );
            }

            // Set the current track to the last track played
            if (
                !trackCompleted &&
                trackPlaytime &&
                _this.trackLoaded === false
            ) {
                _this.currentTrack = parseInt(btn.dataset.trackNumber);
                _this.trackLoaded = true;

                // Load this track into the player
                _this.setTrack(false);
                _this.audio.currentTime = trackPlaytime;

                // Indicate gtrack is loaded
                btn.classList.add("loaded-track");
            }
        });

        // If still no track has been loaded, load the first one
        if (_this.trackLoaded === false) {
            _this.currentTrack = 1;
            _this.trackLoaded = true;

            // Load this track into the player
            _this.setTrack(false);

            // Indicate gtrack is loaded
            _this.playlistItemBtns[0].classList.add("loaded-track");
        }

        // Set the next/prev btn states
        if (_this.previousTrackBtn && _this.nextTrackBtn) {
            _this.updateNextPreviousBtnStates();
        }

        // Set the event listeners
        _this.setupEventListeners();
    }

    /**
     * Sets up the event listeners for the audio player.
     * This is called on page load.
     **/
    setupEventListeners() {
        const _this = this;

        // On Track Loaded
        _this.audio.addEventListener("canplay", _this.setDuration.bind(_this));

        // On Track Ended
        _this.audio.addEventListener("ended", _this.trackEnded.bind(_this));

        // On update, show the amount played
        // and update the scrubbar width
        _this.audio.addEventListener(
            "timeupdate",
            _this.trackTimeChanged.bind(_this)
        );

        // Setup event listeners for playlist links
        _this.playlistItemBtns.forEach((btn) => {
            btn.addEventListener(
                "click",
                (e) => {
                    let selectedTrack = parseInt(btn.dataset.trackNumber);

                    if (selectedTrack !== _this.currentTrack) {
                        _this.resetPlayStatus();
                        _this.currentTrack = null;
                        _this.trackLoaded = false;
                    }

                    if (_this.trackLoaded === false) {
                        _this.currentTrack = parseInt(selectedTrack);
                        _this.setTrack(true);
                    } else {
                        _this.playBack();
                    }
                },
                false
            );
        });

        // If the scrubbar is clicked, move audio file to that point
        _this.scrubbar.addEventListener("click", (e) => {
            // Find % position along scrubbbar clicked
            const w = _this.scrubbar.getBoundingClientRect().width,
                seeked = (e.offsetX / w) * 100;

            // Set audio file currentTime to this position in seconds
            _this.audio.currentTime = (_this.audio.duration / 100) * seeked;
        });

        // On click of the playPause toggle the state of playback
        _this.playPauseBtn.addEventListener(
            "click",
            () => {
                if (_this.trackLoaded === false) {
                    _this.currentTrack = 1;
                    _this.setTrack(true);
                } else {
                    _this.playBack();
                }
            },
            false
        );

        // Next Track Clicked
        if (_this.nextTrackBtn) {
            _this.nextTrackBtn.addEventListener(
                "click",
                () => {
                    if (!_this.nextTrackBtn.disabled) {
                        _this.currentTrack++;
                        _this.trackLoaded = false;
                        _this.resetPlayStatus();
                        _this.setTrack(true);
                    }
                },
                false
            );
        }

        // Previous Track Clicked
        if (_this.previousTrackBtn) {
            _this.previousTrackBtn.addEventListener("click", () => {
                if (!_this.previousTrackBtn.disabled) {
                    _this.currentTrack--;
                    _this.trackLoaded = false;
                    _this.resetPlayStatus();
                    _this.setTrack(true);
                }
            });
        }
    }
}
